import React, { useState, useEffect, createContext, useMemo } from "react";
import Header from "components/templates/common/Detail/Header/Index";
import RealtimeRiskModal from "components/modals/RealTimeRiskModal";
import RiskRankingModal from "components/modals/RiskRankingModal";
import AssetInfo from "components/templates/common/Detail/AssetInfo";
import RiskAlarmRegister from "components/templates/common/Detail/AlarmRegister";
import PriceForecastExplainModal from "components/modals/PriceForecastExplainModal";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import NotiFooter from "components/layouts/m/Footer/noti";
import DetailNotiModal from "components/modals/DetailNotiModal";
import PriceInfo from "components/templates/common/Detail/PriceInfo";
import SDTabs from "components/templates/common/Detail/Tabs";
import { AI, ASSETINFO, PORTFOLIO } from "utils/constant/STATUS";
import { RISK } from "utils/constant/ETC";
import DetailAI from "components/templates/common/Detail/AI/Index";
import Head from "next/head";
import SearchModal from "components/templates/common/Detail/SearchModal";
import { CRYPTO } from "utils/constant/ITME_INFO";
import StrategyAd from "components/templates/common/Detail/StrategyAd";
import DetailMetaHead from "components/templates/common/Detail/MetaHead";
import { useQuery } from "@tanstack/react-query";
import InterestNoti from "components/templates/common/Detail/InterestNoti";
import AdSenseResponsive, {
  AD_SLOTS,
} from "components/ads/AdSenseResponsive";

const convertType = (type: string | undefined) => {
  let t = "";
  switch (type) {
    case "ai":
      t = AI;
      break;
    case "risk":
      t = RISK;
      break;
    case "portfolio":
      t = PORTFOLIO;
      break;
    case "assetinfo":
      t = ASSETINFO;
      break;
    default:
      t = AI;
  }
  return t;
};

function isEveryOtherPropertyNull(object: any): boolean {
  const { ITEM_ENG_NM, ITEM_CD, ITEM_CD_DL, ...rest } = object;
  if (!object) {
    return true;
  }
  return Object.values(rest).every((value) => value === null);
}

function Detail({
  detailInfo,
  detailData,
  IS_5MIN,
  prevDayData,
  isHoliday,
  riskTargetDate,
  isMobile,
  isNoPortUser,
  isValidScoreStock,
  isHalt,
  scoreData,
  name,
  isLoginUser,
  orderCategory,
  aiData,
  ticker,
}: any) {
  const router = useRouter();
  const { t } = useTranslation("detail");

  const { type: tabType } = router.query;
  const [type, setType] = useState(
    !tabType ? "AI" : convertType(tabType as string)
  );

  const isNullDetailInfo = detailInfo
    ? isEveryOtherPropertyNull(detailInfo)
    : true;
  const [isRiskModalOpen, setIsRiskModalOpen] = useState(false);
  const [isRiskLevelModalOpen, setIsRiskLevelModalOpen] = useState(false);
  const [toggleActive, setToggleActive] = useState(false);
  const [alarmRegister, setAlarmRegister] = useState(false);
  const [searchModal, setSearchModal] = useState(false);

  const [priceForecastExplainModal, setPriceForecastExplainModal] =
    useState(false);

  const [notiModal, setNotiModal] = useState(false);

  const [stAdvisible, setStAdvisible] = useState(false);

  const { data: sCordData, isLoading: sCodeLoading } = useQuery({
    queryKey: ["sCode", ticker],
    queryFn: async () => {
      return fetch(`/api/detail/strategystock?ticker=${ticker}`).then((res) =>
        res.json()
      );
    },
    enabled: !!ticker && detailData?.CAT === "Stock" && !!detailData,
  });

  useEffect(() => {
    const detailNotiModalHide = localStorage.getItem("detailNotiModalHide");
    if (detailNotiModalHide && new Date(detailNotiModalHide) > new Date()) {
      setNotiModal(false);
      //안보이기
    } else {
      setNotiModal(true);
    }
  }, []);
  useEffect(() => {
    window?.scrollTo(0, 0);
    if (!detailData) return;
    if (!sCordData) return;
    const detailStrategyAd = localStorage.getItem(
      `detail-st-ad-${
        router.locale === "ko"
          ? detailData?.ITEM_KR_NM
          : detailData?.ITEM_ENG_NM
      }`
    );

    // if (!detailStrategyAd) {
    //   if (sCordData) setStAdvisible(true);
    //   return;
    // }
    // const stAdvisible =
    //   (sCordData && new Date(detailStrategyAd) < new Date()) || false;
    // setStAdvisible(stAdvisible);
  }, [detailData, sCordData]);

  useEffect(() => {
    switch (tabType) {
      case "price":
        setType(AI);
        break;
      case "risk":
        setType(RISK);
        break;
      case "portfolio":
        setType(PORTFOLIO);
        break;
      case "assetinfo":
        setType(ASSETINFO);
        break;
      default:
        setType(AI);
        break;
    }
  }, [tabType]);

  return (
    <>
      <DetailMetaHead
        riskTargetDate={riskTargetDate}
        name={name}
        aiData={aiData}
        ticker={ticker}
      />
      <main className="min-w-[360px] w-screen max-w-[800px] bg-white">
        {alarmRegister && (
          <RiskAlarmRegister
            setModalOpen={setAlarmRegister}
            detailData={detailData}
          />
        )}
        {!alarmRegister && !searchModal && (
          <>
            <Header
              isMobile={isMobile}
              detailData={detailData}
              setAlarmRegister={setAlarmRegister}
              isLoginUser={isLoginUser}
            />
            <InterestNoti isMobile={isMobile} detailData={detailData} />
            {/* 
            <StrategyAd
              stAdvisible={stAdvisible}
              isMobile={isMobile}
              itemName={
                router.locale === "ko"
                  ? detailData?.ITEM_KR_NM
                  : detailData?.ITEM_CD_DL
              }
              sCordData={sCordData}
              sCodeLoading={sCodeLoading}
            /> */}
            <PriceInfo
              stAdvisible={stAdvisible}
              isMobile={isMobile}
              detailData={detailData}
              toggleActive={toggleActive}
              setToggleActive={setToggleActive}
              setIsRiskModalOpen={setIsRiskModalOpen}
              isHoliday={isHoliday}
              isHalt={isHalt}
              setSearchModal={setSearchModal}
            />
            <AdSenseResponsive slot={AD_SLOTS.detailUpper} />
            {detailData?.CAT === CRYPTO && (
              <SDTabs
                type={type}
                setType={setType}
                detailData={detailData}
                isNullDetailInfo={isNullDetailInfo}
                t={t}
                isValidScoreStock={isValidScoreStock}
              />
            )}
            {detailData?.CAT !== CRYPTO ? (
              <DetailAI
                riskTargetDate={riskTargetDate}
                detailData={detailData}
                toggleActive={toggleActive}
                type={type}
                setType={setType}
                prevDayData={prevDayData}
                isNoPortUser={isNoPortUser}
                isValidScoreStock={isValidScoreStock}
                isHalt={isHalt}
                scoreData={scoreData}
                isHoliday={isHoliday}
                setPriceForecastExplainModal={setPriceForecastExplainModal}
                isMobile={isMobile}
                isLoginUser={isLoginUser}
                orderCategory={orderCategory}
                aiData={aiData}
              />
            ) : type === AI ? (
              <DetailAI
                riskTargetDate={riskTargetDate}
                detailData={detailData}
                toggleActive={toggleActive}
                type={type}
                setType={setType}
                prevDayData={prevDayData}
                isNoPortUser={isNoPortUser}
                isValidScoreStock={isValidScoreStock}
                isHalt={isHalt}
                isHoliday={isHoliday}
                setPriceForecastExplainModal={setPriceForecastExplainModal}
                isMobile={isMobile}
              />
            ) : null}
            {!isNullDetailInfo && type === ASSETINFO && (
              <AssetInfo
                type={type}
                setType={setType}
                cat={detailData.CAT && detailData.CAT}
                detailInfo={detailInfo}
              />
            )}
          </>
        )}

        {isRiskModalOpen && (
          <RealtimeRiskModal
            setModalOpen={setIsRiskModalOpen}
            isModalOpen={isRiskModalOpen}
          />
        )}
        {isRiskLevelModalOpen && (
          <RiskRankingModal
            setModalOpen={setIsRiskLevelModalOpen}
            isModalOpen={isRiskLevelModalOpen}
          />
        )}
        {priceForecastExplainModal && (
          <PriceForecastExplainModal
            setModal={setPriceForecastExplainModal}
            isModalOpen={priceForecastExplainModal}
          />
        )}
        {searchModal && <SearchModal setSearchModal={setSearchModal} />}
        {notiModal && <DetailNotiModal setModalOpen={setNotiModal} />}

        <NotiFooter isMobilePaddingAdd={true} />
      </main>
    </>
  );
}

export default Detail;

//1개월 리스크 데이터(only isValidScoreStock)
// const [monthlyData, isMonthlyRiskValid] = useMonthForecast(
//   detailData.ITEM_CD,
//   isValidScoreStock
// );
// const [upjongThemeList, isValid] = useUpjongFetch({
//   ticker: detailData.ITEM_CD,
//   lis
// t: true,
// });

// const [selectedUpjongTheme, setSelectedUpjongTheme] = useState({
//   TU_CD: 0,
//   TU_NM: "",
// });
// monthlyData={monthlyData}

{
  /*
        {price && (
          <MonthPriceForecast
            detailData={detailData}
            riskTargetDate={riskTargetDate}
          />
        )}
        {risk && (
          <MonthRiskCompare
            detailData={detailData}
            riskTargetDate={riskTargetDate}
          />
        )}
        {daliyrisk && (
          <DaliyRiskModal
            riskTargetDate={riskTargetDate}
            detailData={detailData}
          />
        )}
      {industry && <IndustryDetail detailData={detailData} />} */
}

{
  /**
       {!alarmRegister && !price && !risk && !industry && !daliyrisk && (
          <>
        
          </>
        )}
  */
}

{
  /*
            {detailData?.CAT !== "Index" && type === PORTFOLIO && (
              <DetailPortfolio
                toggleActive={toggleActive}
                detailData={detailData}
                type={type}
                setType={setType}
                isNoPortUser={isNoPortUser}
              />
            )}

            */
}

{
  /**
      {type === RISK && isValidScoreStock && (
              <DetailRisk
                detailData={detailData}
                IS_5MIN={IS_5MIN}
                toggleActive={toggleActive}
                realTimeTwodaysHistoryData={realTimeTwodaysHistoryData}
                riskTargetDate={riskTargetDate}
                setPriceForecastExplainModal={setPriceForecastExplainModal}
                prevDayData={prevDayData}
                setIsRiskLevelModalOpen={setIsRiskLevelModalOpen}
                monthlyData={monthlyData}
                isHoliday={isHoliday}
              />
            )}

  */
}
